import { useEffect, useState } from 'react'
import { BooksitoutServer } from '../../../../config/BooksitoutServer'
import { UserBookRecommendationResponse } from './UserBookRecommendationResponse'
import Paging from '../../../../common/hooks/Paging'

const useUserBookRecommendations = (size: number = 5) => {
	const [page, setPage] = useState<number>(1)
	const [isLast, setIsLast] = useState<boolean>(false)
	const [isLoading, setIsLoading] = useState<boolean>(true)
	const [recommendations, setRecommendations] = useState<UserBookRecommendationResponse[]>([])

	useEffect(() => {
		if (!isLast) {
			BooksitoutServer
				.get(`/v1/book-user-recommendations?page=${page}&size=${size}`)
				.then((res) => {
					setRecommendations((prev) => [...prev, ...res.data.contents])
					setIsLast(res.data.isLast)
				})
				.finally(() => setIsLoading(false))
		}
	}, [page])

	const paging: Paging = {
		hasMore: !isLast,
		totalPages: 0,
		fetchNext: () => setPage((prev) => prev + 1),
	}

	return [isLoading, recommendations, setRecommendations, paging] as const
}

export default useUserBookRecommendations
